import React, { useMemo } from "react";
import { Tooltip } from "@shared/components";
import { PayPerLeadSubscription } from "@containers/PayPerLead/interface";
import { ReactComponent as IconInfo } from "@assets/files/icons/general/info.svg";
import { MIN_REMAINING_BALANCE } from "@containers/PayPerLead/store/constants";
import { Price } from "@containers/PayPerLead/components/CheckoutDetails";

import "./index.scss";

interface MonthlyBalanceProps {
  subscriptions: PayPerLeadSubscription[];
}

const MonthlyBalance = ({ subscriptions }: MonthlyBalanceProps) => {
  const monthlyDepositLeft = useMemo(
    () => subscriptions?.reduce((acc, s) => acc + (s?.remaining_balance ?? 0), 0) ?? 0,
    [subscriptions],
  );
  const tooltipContent = (
    <div className="monthly-balance-tooltip">
      <p>
        Funds from your balance are used to pay <br /> for leads as they are delivered. You will be charged <br /> when
        any of your subscriptions balance falls <br /> below ${MIN_REMAINING_BALANCE / 100}.
      </p>
    </div>
  );

  return (
    <div className="card-item">
      <div className="content">
        <div className="header">
          <div className="title">TOTAL BALANCE</div>
        </div>
        <div className="payment-summary">
          <div className="payment-details">
            <div className="balance-amount">
              <Price amount={monthlyDepositLeft} />
            </div>
            <div className="payment-due">
              <span>Payment due if subscription has a low balance</span>
              <div className="payment-due-tooltip">
                <Tooltip content={tooltipContent} position="bottom-right">
                  <IconInfo />
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonthlyBalance;
